import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/purchase_offers'
export default {
  namespaced: true,
  state: {
    dataList: [],
    purchaseOfferStockStatuses: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      onumber: null,
      sdate: null,
      edate: null,
      title: null,
      content: null,
      offer_price: null,
      offer_amount: null,
      id_purchase_offer_status: null,
      id_confirmed_user: null,
      id_confirmed_suppliers: null,
      id_users: null,
      confirmed: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    search: {
      keyword: null,
      id_users: null,
      id_purchase_offer_status: null,
      detailSearch: false,
    },
    dataLoading: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    purchaseOfferCompleted(state) {
      return state.purchaseOfferStockStatuses
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    search(state) {
      return state.search
    },
    dataLoading(state) {
      return state.dataLoading
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_PURCHASE_OFFER_STOCK_STATUSES(state, data) {
      state.purchaseOfferStockStatuses = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        onumber: null,
        sdate: null,
        edate: null,
        title: null,
        content: null,
        offer_price: null,
        offer_amount: null,
        id_purchase_offer_status: null,
        id_confirmed_user: null,
        id_confirmed_suppliers: null,
        id_users: null,
        confirmed: null,
      }
    },
    SET_DATA_LOADING(state, data) {
      state.dataLoading = data
    },
    RESET_SEARCH(state) {
      state.search = {
        keyword: null,
        id_users: null,
        id_purchase_offer_status: null,
        detailSearch: false,
      }
    },

  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_DATA_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, params) {
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify({
        where: {
          'purchase_offers.id': params.id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          commit('SET_DATA_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    getPurchaseOfferStatusList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/PurchaseStockStatus`, data)
        .then(response => {
          commit('SET_PURCHASE_OFFER_STOCK_STATUSES', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM')
    },
  },
}
